import React from 'react';
import PropTypes from 'prop-types';
import { Layer, Box, Text } from 'grommet';
import { useAppTheme } from '@Components/Context';
import { DatetimeCalendar, FlexibleSelectDropdown } from '@Components/Control';

const DateFilterDropdown = ({
  small,
  query,
  onDateSelect,
  onQueryChange,
  dateFilterOptions,
}) => {
  const [modalType, setModalType] = React.useState(null);
  const { theme: { page } } = useAppTheme();

  // Dynamic label
  let label = 'Date filters';
  const activeFilters = dateFilterOptions
    .map((opt) => query[opt.api])
    .filter(Boolean);
  if (activeFilters.length) {
    label = dateFilterOptions
      .filter((opt) => query[opt.api])
      .map((opt) => `${opt.display}: ${new Date(query[opt.api]).toLocaleDateString()}`)
      .join(', ');
  }

  const handleSelect = (option) => {
    if (!option) {
      // Reset all date filters
      dateFilterOptions.forEach((opt) => onQueryChange(opt.api, null));
      return;
    }
    setModalType(option);
  };

  const handleCloseModal = () => {
    setModalType(null);
  };

  const handleDateChange = (date) => {
    if (modalType) {
      const isoDate = new Date(date).toISOString().replace('.000', '');
      onDateSelect(modalType, isoDate);
      setModalType(null);
    }
  };

  return (
    <>
      <FlexibleSelectDropdown
        textColor={page.tableText}
        handleItemSelect={handleSelect}
        flexibleOptions={dateFilterOptions}
        noSelectionLabel={label}
        displayKey="display"
        valueKey="api"
        iconPath="images/calendar-icon-dark.svg"
        customPad="0.2rem 0.3rem"
        selectedOption={label}
        withReset={!!activeFilters.length}
        small={small}
      />
      {modalType && (
        <Layer
          onEsc={handleCloseModal}
          onClickOutside={handleCloseModal}
          responsive={false}
          animate={false}
        >
          <Box direction="column" pad={{ top: '1rem' }}>
            <Text size="1.15rem" weight={600} color={page.modalText} textAlign="center">
              {dateFilterOptions.find((opt) => opt.api === modalType).display}
              :
            </Text>
            <DatetimeCalendar
              hideTimeZone
              showCloseButton
              showTimeSelect={false}
              handleClose={handleCloseModal}
              small={small}
              calendarMode="single"
              setDate={handleDateChange}
              dateValue={query[modalType] ? new Date(query[modalType]) : new Date()}
            />
          </Box>
        </Layer>
      )}
    </>
  );
};

DateFilterDropdown.propTypes = {
  small: PropTypes.bool.isRequired,
  query: PropTypes.object.isRequired,
  onDateSelect: PropTypes.func.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  dateFilterOptions: PropTypes.array.isRequired,
};

export default DateFilterDropdown;
